import api from "./api";

// ✅ Get all tenders
export const getAllTenders = async () => {
  const res = await api.get("/Tender");
  return res.data;
};

// ✅ Get tender by ID
export const getTenderById = async (id) => {
  const res = await api.get(`/Tender/${id}`);
  return res.data;
};

// ✅ Create tender (with file)
export const createTender = async (tenderData) => {
  const formData = new FormData();

  // Append fields
  formData.append("Title", tenderData.Title);
  formData.append("Description", tenderData.Description);
  formData.append("PublishDate", tenderData.PublishDate);
  formData.append("ClosingDate", tenderData.ClosingDate);
  formData.append("CreatedBy", tenderData.CreatedBy || "Admin");

  // Append file if exists
  if (tenderData.File) {
    formData.append("file", tenderData.File);
  }

  const res = await api.post("/Tender", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// ✅ Update tender (with file optional)
export const updateTender = async (id, tenderData) => {
  const formData = new FormData();

  formData.append("Id", id);
  formData.append("Title", tenderData.Title);
  formData.append("Description", tenderData.Description);
  formData.append("PublishDate", tenderData.PublishDate);
  formData.append("ClosingDate", tenderData.ClosingDate);
  formData.append("CreatedBy", tenderData.CreatedBy || "Admin");

  if (tenderData.File) {
    formData.append("file", tenderData.File);
  }

  const res = await api.put(`/Tender/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// ✅ Delete tender
export const deleteTender = async (id) => {
  const res = await api.delete(`/Tender/${id}`);
  return res.data;
};

